import DataStructure, { sanitize } from "./DataStructure.js";
import { uid } from "quasar";
import { deepFreeze, formatCurrency, formatPercentage } from "../util/misc.js";

export const CUSTOMER_QUOTE_DISCOUNT_ITEM_FIELDS = {
  id: "",
  itemType: "discount",
  line: 0,
  category: "",
  description: "",
  type: "",
  value: 0,
};
deepFreeze(CUSTOMER_QUOTE_DISCOUNT_ITEM_FIELDS);

export default class CustomerQuoteDiscountItem extends DataStructure {
  constructor(data = {}) {
    data = sanitize(data, CUSTOMER_QUOTE_DISCOUNT_ITEM_FIELDS);

    if (!data.id) {
      data.id = uid().slice(-12);
    }

    super(data);
  }

  // Editing

  get isValid() {
    return Boolean(
      this.data.description &&
        this.data.value > 0 &&
        (this.data.type === "fixed" ||
          (this.data.type === "percentage" && this.data.value <= 100))
    );
  }

  // Formatting

  get value() {
    if (this.data.type === "percentage") {
      return formatPercentage(this.data.value);
    } else {
      return formatCurrency(this.data.value);
    }
  }

  summary(length = 200) {
    const description = this.data.description.replace(
      /^\*\*+[^*]+\*\*+\s*/gm,
      ""
    );
    return length === null
      ? description
      : description.slice(0, length) + (description.length > length ? "…" : "");
  }

  toString() {
    return this.summary();
  }
}
